import request from 'superagent/lib/client';
import apiUrlProvider from './ApiURL';

function getCredentialsFromLocalStorage() {
    return JSON.parse(localStorage.getItem('scality-credentials')) || '';
}

export default {

    // Get all user keys
    getKeys: username => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/iam/user/${username}/keys`)
                .set('x-access-token', credentials)
                .send({
                    username,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Delete key
    deleteKey: (username, key) => {
        const credentials = getCredentialsFromLocalStorage();
        const ep = `${apiUrlProvider.apiUrl()}/iam/user/${username}/key/${key}`;

        return new Promise((resolve, reject) => {
            request
                .delete(ep)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Generate access key for user
    createKey: username => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/user/${username}/keys`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

};



/** WEBPACK FOOTER **
 ** ./src/utils/KeysAPI.js
 **/